export default [
    {
        path: '/admin/monthly-deductions',
        name: 'monthly-deductions',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/monthly-deduction/index.vue')
    }
]
